(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-announcement-dismiss]');
    if (!btn) return;
    var id = btn.getAttribute('data-announcement-dismiss');
    var bar = document.getElementById('announcement-' + id);
    if (bar) {
      bar.style.display = 'none';
      try { sessionStorage.setItem('announcement-' + id, 'dismissed'); } catch(e) {}
    }
  });

  document.querySelectorAll('[id^="announcement-"]').forEach(function(bar) {
    var id = bar.id.replace('announcement-', '');
    try {
      if (sessionStorage.getItem('announcement-' + id) === 'dismissed') {
        bar.style.display = 'none';
      }
    } catch(e) {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-related-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-product-recommendations]').forEach(function(root) {
      var productId = root.getAttribute('data-product-id');
      if (!productId) return;
      var sectionId = root.getAttribute('data-section-id');
      var limit = root.getAttribute('data-limit') || '4';
      var grid = root.querySelector('[data-product-recommendations-grid]');
      if (!grid) return;
      function showEmpty() {
        var empty = root.querySelector('[data-product-recommendations-empty]');
        if (empty) {
          empty.hidden = false;
          empty.textContent = root.getAttribute('data-no-results-label') || '';
        }
        if (!root.querySelector('[data-product-recommendations-grid] .product-card')) {
          root.hidden = true;
        }
      }
      function loadRecommendations() {
        if (root.dataset.loaded === 'true') return;
        root.dataset.loaded = 'true';
        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        var url = rootPath + 'recommendations/products?section_id=' + encodeURIComponent(sectionId) + '&product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(limit);
        fetch(url).then(function(res) { return res.text(); }).then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var replacement = doc.querySelector('[data-product-recommendations-grid]');
          if (replacement && replacement.innerHTML.trim()) {
            grid.innerHTML = replacement.innerHTML;
          } else {
            showEmpty();
          }
        }).catch(showEmpty);
      }
      if (!('IntersectionObserver' in window)) { loadRecommendations(); return; }
      var observer = new IntersectionObserver(function(entries) {
        if (entries.some(function(e) { return e.isIntersecting; })) { observer.disconnect(); loadRecommendations(); }
      }, { rootMargin: '300px 0px' });
      observer.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var panel = drawer.querySelector('.cart-drawer__panel');
    var lastActiveElement = null;
    var sectionId = drawer.getAttribute('data-section-id') || '';
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';
    var qtyTimer = null;

    function cartRoot() {
      return rootPath;
    }

    function setOpen(isOpen) {
      drawer.classList.toggle('is-open', isOpen);
      drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      document.body.classList.toggle('cart-drawer-open', isOpen);

      document.querySelectorAll('[data-cart-toggle]').forEach(function(trigger) {
        trigger.setAttribute('aria-controls', panel ? panel.id : '');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      if (isOpen) {
        lastActiveElement = document.activeElement;
        parkUpsellSlots();
        if (panel) panel.focus();
      } else if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus();
      }
    }

    function updateCartCount(count) {
      var toggles = document.querySelectorAll('[data-cart-toggle]');
      toggles.forEach(function(toggle) {
        var badge = toggle.querySelector('.header__cart-count');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'header__cart-count';
          toggle.appendChild(badge);
        }
        badge.textContent = String(count);
        if (count > 0) badge.removeAttribute('hidden');
        else badge.setAttribute('hidden', '');
      });

      var drawerCount = drawer.querySelector('[data-cart-drawer-count]');
      if (drawerCount) {
        drawerCount.textContent = String(count);
        if (count > 0) drawerCount.removeAttribute('hidden');
        else drawerCount.setAttribute('hidden', '');
      }

      var footer = drawer.querySelector('[data-cart-drawer-footer]');
      if (footer) {
        if (count > 0) footer.removeAttribute('hidden');
        else footer.setAttribute('hidden', '');
      }
    }

    function collectUpsellSlots() {
      return Array.prototype.slice.call(document.querySelectorAll(
        '[id^="reconvert-slot-cartDrawer"], [id^="cartDrawer-slot-"], [data-cart-drawer] [id^="reconvert-slot-"]'
      ));
    }

    function parkUpsellSlots() {
      var host = drawer.querySelector('[data-cart-drawer-upsell]');
      if (!host) return;
      collectUpsellSlots().forEach(function(slot) {
        if (slot.parentNode !== host) host.appendChild(slot);
      });
    }

    function refreshDrawerContent() {
      var slots = collectUpsellSlots();
      var parking = document.createDocumentFragment();
      slots.forEach(function(slot) { parking.appendChild(slot); });

      return fetch(cartRoot() + 'cart?section_id=' + encodeURIComponent(sectionId) + '&_=' + Date.now(), {
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('drawer_refresh_failed');
          return response.text();
        })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var nextDrawer = doc.querySelector('[data-cart-drawer]');
          if (!nextDrawer) return;

          var nextMain = nextDrawer.querySelector('[data-cart-drawer-main]');
          var currentMain = drawer.querySelector('[data-cart-drawer-main]');
          if (nextMain && currentMain) currentMain.innerHTML = nextMain.innerHTML;

          var nextSubtotal = nextDrawer.querySelector('[data-cart-drawer-subtotal]');
          var currentSubtotal = drawer.querySelector('[data-cart-drawer-subtotal]');
          if (nextSubtotal && currentSubtotal) currentSubtotal.innerHTML = nextSubtotal.innerHTML;

          var nextCount = nextDrawer.querySelector('[data-cart-drawer-count]');
          var currentCount = drawer.querySelector('[data-cart-drawer-count]');
          if (nextCount && currentCount) {
            currentCount.textContent = nextCount.textContent;
            if (nextCount.hasAttribute('hidden')) currentCount.setAttribute('hidden', '');
            else currentCount.removeAttribute('hidden');
          }

          var nextFooter = nextDrawer.querySelector('[data-cart-drawer-footer]');
          var currentFooter = drawer.querySelector('[data-cart-drawer-footer]');
          if (nextFooter && currentFooter) {
            if (nextFooter.hasAttribute('hidden')) currentFooter.setAttribute('hidden', '');
            else currentFooter.removeAttribute('hidden');
          }

          var nextPanel = nextDrawer.querySelector('.cart-drawer__panel');
          if (nextPanel && panel) {
            panel.id = nextPanel.id || panel.id;
            panel.setAttribute('aria-label', nextPanel.getAttribute('aria-label') || panel.getAttribute('aria-label') || '');
          }

          var host = drawer.querySelector('[data-cart-drawer-upsell]');
          if (host) host.appendChild(parking);
          parkUpsellSlots();
        })
        .catch(function() {
          var host = drawer.querySelector('[data-cart-drawer-upsell]');
          if (host) host.appendChild(parking);
        });
    }

    function refreshCartPage() {
      var cartPage = document.querySelector('[data-cart-page]');
      if (!cartPage) return Promise.resolve();
      var cartSectionId = cartPage.getAttribute('data-section-id');
      if (!cartSectionId) return Promise.resolve();

      return fetch(cartRoot() + 'cart?section_id=' + encodeURIComponent(cartSectionId) + '&_=' + Date.now(), {
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('cart_page_refresh_failed');
          return response.text();
        })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var nextPage = doc.querySelector('[data-cart-page]');
          if (nextPage) cartPage.replaceWith(nextPage);
        })
        .catch(function() {});
    }

    function changeLine(key, quantity) {
      return fetch(cartRoot() + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
    }

    function trapFocus(event) {
      if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      if (!panel) return;

      var focusableElements = panel.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusableElements.length) {
        event.preventDefault();
        return;
      }

      var first = focusableElements[0];
      var last = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    document.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-cart-toggle]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        setOpen(!drawer.classList.contains('is-open'));
        return;
      }

      var closeTrigger = event.target.closest('[data-cart-drawer-close]');
      if (closeTrigger) {
        event.preventDefault();
        setOpen(false);
      }
    }, true);

    document.addEventListener('keydown', function(event) {
      if (!drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        setOpen(false);
        return;
      }
      trapFocus(event);
    });

    document.addEventListener('change', function(event) {
      var input = event.target.closest('[data-cart-drawer] [name="updates[]"]');
      if (!input) return;
      var item = input.closest('[data-line-key]');
      if (!item) return;
      var quantity = parseInt(input.value, 10);
      if (isNaN(quantity) || quantity < 0) return;
      window.clearTimeout(qtyTimer);
      qtyTimer = window.setTimeout(function() {
        changeLine(item.getAttribute('data-line-key'), quantity);
      }, 220);
    });

    function refreshFromCartEvent(event) {
      window.__spwCartUpdatedAt = Date.now();
      var detail = event && event.detail ? event.detail : {};
      var shouldOpen = detail.openDrawer === true;
      var refreshPromise = Promise.resolve();

      if (shouldOpen) setOpen(true);

      if (detail.cart && typeof detail.cart.item_count === 'number') {
        updateCartCount(detail.cart.item_count);
      } else {
        refreshPromise = fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function(res) { return res.ok ? res.json() : null; })
          .then(function(cart) {
            if (cart && typeof cart.item_count === 'number') {
              updateCartCount(cart.item_count);
            }
          })
          .catch(function() {});
      }

      return Promise.all([refreshPromise, refreshDrawerContent(), refreshCartPage()]);
    }

    document.addEventListener('theme:open:cart-drawer', function() {
      setOpen(true);
    });

    document.addEventListener('theme:update:cart', function() {
      refreshFromCartEvent({ detail: { openDrawer: false } });
    });

    document.addEventListener('cart:updated', function(event) {
      refreshFromCartEvent(event);
    });

    var upsellHost = drawer.querySelector('[data-cart-drawer-upsell]');
    if (upsellHost && typeof MutationObserver === 'function') {
      var parking = false;
      var observer = new MutationObserver(function() {
        if (parking) return;
        parking = true;
        parkUpsellSlots();
        parking = false;
      });
      observer.observe(drawer, { childList: true, subtree: true });
    }

    parkUpsellSlots();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionFilterDrawer {
    constructor() {
      this.toggle = document.querySelector('[data-filter-toggle]');
      this.drawer = document.querySelector('[data-filter-drawer]');
      this.overlay = document.querySelector('[data-filter-overlay]');
      this.closeBtn = document.querySelector('[data-filter-close]');
      this.countBadge = document.querySelector('[data-filter-count]');

      if (!this.toggle || !this.drawer) return;

      this.init();
    }

    init() {
      this.toggle.addEventListener('click', () => this.open());
      this.closeBtn?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());
      
      // Close on Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) {
          this.close();
        }
      });

      // Update active filter count
      this.updateFilterCount();
      
      // Listen for filter changes
      const form = this.drawer.querySelector('[data-faceted-form]');
      if (form) {
        form.addEventListener('change', () => {
          setTimeout(() => this.updateFilterCount(), 100);
        });
      }
    }

    open() {
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.overlay?.classList.add('is-visible');
      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      
      // Focus first interactive element
      const firstInput = this.drawer.querySelector('input, button');
      firstInput?.focus();
    }

    close() {
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.overlay?.classList.remove('is-visible');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      this.toggle.focus();
    }

    updateFilterCount() {
      const activeFilters = this.drawer.querySelectorAll('input[type="checkbox"]:checked, input[type="number"][value]:not([value=""])');
      const count = activeFilters.length;
      
      if (this.countBadge) {
        this.countBadge.textContent = count > 0 ? count : '';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new CollectionFilterDrawer());
  } else {
    new CollectionFilterDrawer();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complementary-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-complementary-products]').forEach(function(root) {
      var productId = root.getAttribute('data-product-id');
      if (!productId) return;

      var sectionId = root.getAttribute('data-section-id');
      var limit = root.getAttribute('data-limit') || '4';
      var grid = root.querySelector('[data-complementary-products-grid]');
      if (!grid) return;

      function loadComplementaryProducts() {
        if (root.dataset.loaded === 'true') return;
        root.dataset.loaded = 'true';

        var url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId)
          + '&product_id=' + encodeURIComponent(productId)
          + '&limit=' + encodeURIComponent(limit)
          + '&intent=complementary';

        fetch(url)
          .then(function(res) { return res.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newSection = doc.querySelector('[data-complementary-products]');
            if (newSection) {
              root.innerHTML = newSection.innerHTML;
            }
          })
          .catch(function() {
            /* Hide section gracefully on error */
            var placeholder = root.querySelector('[data-complementary-products-placeholder]');
            if (placeholder) {
              placeholder.remove();
            }
          });
      }

      if (!('IntersectionObserver' in window)) {
        loadComplementaryProducts();
        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        if (entries.some(function(entry) { return entry.isIntersecting; })) {
          observer.disconnect();
          loadComplementaryProducts();
        }
      }, {
        rootMargin: '300px 0px'
      });

      observer.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function findActivator(node, depth) {
      if (!node || depth > 8) return null;
      var root = node.shadowRoot;
      if (!root) return null;
      var btn = root.querySelector(
        'button.activator, button[part="activator"], button[aria-label="Support"]'
      );
      if (btn) return btn;
      var nested = root.querySelectorAll('*');
      for (var i = 0; i < nested.length; i++) {
        var found = findActivator(nested[i], depth + 1);
        if (found) return found;
      }
      return null;
    }

    function openShopifyInbox() {
      var hosts = document.querySelectorAll('shopify-chat, inbox-online-store-chat, #ShopifyChat');
      for (var i = 0; i < hosts.length; i++) {
        var btn = findActivator(hosts[i], 0);
        if (btn) {
          btn.click();
          return true;
        }
      }
      return false;
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-open-shopify-inbox]');
      if (!trigger) return;
      event.preventDefault();
      openShopifyInbox();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-countdown-root]').forEach(function(root) {
      var targetDateRaw = root.getAttribute('data-target-date');
      if (!targetDateRaw) return;

      var target = new Date(targetDateRaw).getTime();
      if (Number.isNaN(target)) return;

      var grid = root.querySelector('[data-countdown-grid]');
      var expiredNode = root.querySelector('[data-countdown-expired]');
      var daysNode = root.querySelector('[data-countdown-days]');
      var hoursNode = root.querySelector('[data-countdown-hours]');
      var minutesNode = root.querySelector('[data-countdown-minutes]');
      var secondsNode = root.querySelector('[data-countdown-seconds]');
      if (!daysNode || !hoursNode || !minutesNode || !secondsNode) return;

      function pad(value) {
        return String(value).padStart(2, '0');
      }

      function render() {
        var now = Date.now();
        var diff = target - now;
        if (diff <= 0) {
          daysNode.textContent = '00';
          hoursNode.textContent = '00';
          minutesNode.textContent = '00';
          secondsNode.textContent = '00';
          if (expiredNode) expiredNode.hidden = false;
          if (grid) grid.setAttribute('aria-hidden', 'true');
          return true;
        }

        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        var minutes = Math.floor((diff / (1000 * 60)) % 60);
        var seconds = Math.floor((diff / 1000) % 60);

        daysNode.textContent = pad(days);
        hoursNode.textContent = pad(hours);
        minutesNode.textContent = pad(minutes);
        secondsNode.textContent = pad(seconds);
        return false;
      }

      var done = render();
      if (done) return;

      var timer = window.setInterval(function() {
        if (render()) {
          window.clearInterval(timer);
        }
      }, 1000);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-featured-product]');
    if (!root) return;

    /* ── Media gallery thumbnail switching ── */
    var thumbs = root.querySelectorAll('[data-fp-thumb-index]');
    var mediaItems = root.querySelectorAll('[data-fp-media-index]');

    if (thumbs.length > 1) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var index = thumb.getAttribute('data-fp-thumb-index');

          mediaItems.forEach(function(item) {
            item.classList.toggle('featured-product__media-item--active',
              item.getAttribute('data-fp-media-index') === index);
          });

          thumbs.forEach(function(t) {
            t.classList.toggle('featured-product__thumb--active',
              t.getAttribute('data-fp-thumb-index') === index);
          });
        });
      });
    }

    /* ── Add-to-cart form handling ── */
    var form = root.querySelector('[data-featured-product-form]');
    if (!form) return;

    var variantsNode = form.querySelector('[data-featured-variants]');
    var variantIdInput = form.querySelector('[data-featured-variant-id]');
    var optionInputs = form.querySelectorAll('[data-featured-option]');
    var addButton = form.querySelector('[data-featured-add-button]');
    var dynamicCheckout = form.querySelector('[data-featured-dynamic-checkout]');
    var feedbackNode = form.querySelector('[data-featured-feedback]');
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';

    if (!variantsNode || !variantIdInput || !addButton) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      return;
    }

    function setFeedback(message, isError, withViewCartLink) {
      if (!feedbackNode || !message) return;

      var cartUrl = feedbackNode.getAttribute('data-cart-url') || (rootPath + 'cart');
      var viewCartLabel = feedbackNode.getAttribute('data-view-cart-label') || '';

      feedbackNode.classList.toggle('is-error', Boolean(isError));
      feedbackNode.hidden = false;

      if (withViewCartLink && viewCartLabel) {
        feedbackNode.innerHTML = message + ' <a href="' + cartUrl + '">' + viewCartLabel + '</a>';
      } else {
        feedbackNode.textContent = message;
      }
    }

    function updateCartCount(count) {
      var toggles = document.querySelectorAll('[data-cart-toggle]');
      toggles.forEach(function(toggle) {
        var badge = toggle.querySelector('.header__cart-count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'header__cart-count';
            toggle.appendChild(badge);
          }
          badge.textContent = String(count);
        } else if (badge) {
          badge.remove();
        }
      });
    }

    function fetchCartState() {
      return fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(cart) {
          if (cart && typeof cart.item_count === 'number') {
            updateCartCount(cart.item_count);
          }
          return cart;
        })
        .catch(function() { return null; });
    }

    function syncVariant(preserveFeedback) {
      if (!optionInputs.length) {
        if (feedbackNode && !preserveFeedback) {
          feedbackNode.hidden = true;
          feedbackNode.classList.remove('is-error');
        }
        return;
      }

      var selectedOptions = Array.prototype.map.call(optionInputs, function(input) {
        return input.value;
      });

      var matchedVariant = variants.find(function(variant) {
        return selectedOptions.every(function(optionValue, index) {
          return variant.options[index] === optionValue;
        });
      });

      if (!matchedVariant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = addButton.getAttribute('data-sold-label') || '';
        }
        return;
      }

      variantIdInput.value = matchedVariant.id;

      if (addButton) {
        if (matchedVariant.available) {
          addButton.disabled = false;
          addButton.textContent = addButton.getAttribute('data-add-label') || '';
        } else {
          addButton.disabled = true;
          addButton.textContent = addButton.getAttribute('data-sold-label') || '';
        }
      }

      if (dynamicCheckout) {
        dynamicCheckout.hidden = !matchedVariant.available;
      }

      if (feedbackNode && !preserveFeedback) {
        feedbackNode.hidden = true;
        feedbackNode.classList.remove('is-error');
      }
    }

    if (optionInputs.length) {
      optionInputs.forEach(function(input) {
        input.addEventListener('change', syncVariant);
      });
    }

    syncVariant();

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      if (addButton.disabled) return;

      var defaultLabel = addButton.getAttribute('data-add-label') || addButton.textContent;
      var addingLabel = addButton.getAttribute('data-adding-label') || defaultLabel;
      var addedLabel = addButton.getAttribute('data-added-label') || defaultLabel;
      var errorLabel = addButton.getAttribute('data-error-label') || defaultLabel;
      var addedMessage = feedbackNode ? (feedbackNode.getAttribute('data-added-message') || addedLabel) : addedLabel;
      var errorMessage = feedbackNode ? (feedbackNode.getAttribute('data-error-message') || errorLabel) : errorLabel;

      var formData = new FormData(form);
      var endpoint = form.getAttribute('action') || (rootPath + 'cart/add');
      if (!endpoint.endsWith('.js')) {
        endpoint += '.js';
      }
      var requestFailed = false;

      addButton.disabled = true;
      addButton.classList.add('is-loading');
      addButton.setAttribute('aria-busy', 'true');
      addButton.textContent = addingLabel;

      fetch(endpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(function(res) {
          if (!res.ok) {
            var error = new Error('add_failed');
            error.status = res.status;
            throw error;
          }
          return res.json();
        })
        .then(function() {
          addButton.textContent = addedLabel;
          setFeedback(addedMessage, false, true);
          return fetchCartState();
        })
        .then(function(cart) {
          var detail = { source: 'featured-product', openDrawer: true };
          if (cart) detail.cart = cart;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
        })
        .catch(function() {
          requestFailed = true;
          addButton.textContent = errorLabel;
          setFeedback(errorMessage, true, false);
        })
        .finally(function() {
          addButton.classList.remove('is-loading');
          addButton.removeAttribute('aria-busy');
          window.setTimeout(function() {
            syncVariant(requestFailed);
            if (!optionInputs.length) {
              var currentVariant = variants.find(function(variant) {
                return String(variant.id) === String(variantIdInput.value);
              }) || variants[0];
              if (currentVariant && currentVariant.available) {
                addButton.disabled = false;
                addButton.textContent = addButton.getAttribute('data-add-label') || defaultLabel;
              } else {
                addButton.disabled = true;
                addButton.textContent = addButton.getAttribute('data-sold-label') || defaultLabel;
              }
            }
          }, 1100);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-image-comparison]').forEach(function(root) {
      var frame = root.querySelector('[data-comparison-frame]');
      var range = root.querySelector('[data-comparison-range]');
      if (!frame || !range) return;

      function update() {
        var value = Number(range.value) || 50;
        var isRtl = document.documentElement.getAttribute('dir') === 'rtl';
        var logical = isRtl ? 100 - value : value;
        frame.style.setProperty('--comparison-position', logical + '%');
      }

      range.addEventListener('input', update);
      update();
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-password-section]').forEach(function(root) {
      var dateRaw = root.getAttribute('data-launch-date');
      if (!dateRaw) return;
      var target = new Date(dateRaw).getTime();
      if (Number.isNaN(target)) return;

      var daysNode = root.querySelector('[data-password-days]');
      var hoursNode = root.querySelector('[data-password-hours]');
      var minutesNode = root.querySelector('[data-password-minutes]');
      if (!daysNode || !hoursNode || !minutesNode) return;

      function pad(v) { return String(v).padStart(2, '0'); }
      function update() {
        var diff = target - Date.now();
        if (diff <= 0) {
          daysNode.textContent = '00';
          hoursNode.textContent = '00';
          minutesNode.textContent = '00';
          return true;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff / 3600000) % 24);
        var mins = Math.floor((diff / 60000) % 60);
        daysNode.textContent = pad(days);
        hoursNode.textContent = pad(hours);
        minutesNode.textContent = pad(mins);
        return false;
      }

      if (!update()) {
        var timer = window.setInterval(function() {
          if (update()) window.clearInterval(timer);
        }, 1000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-popup-root]').forEach(function(root) {
      var dialog = root.querySelector('[data-popup-dialog]');
      var closeBtn = root.querySelector('[data-popup-close]');
      if (!dialog || !closeBtn) return;

      var storageKey = root.getAttribute('data-storage-key');
      var delay = Number(root.getAttribute('data-delay')) || 3;
      var frequency = root.getAttribute('data-display-frequency') || 'once';
      var lastActiveElement = null;

      function getStorage() {
        if (frequency === 'session') return sessionStorage;
        if (frequency === 'once') return localStorage;
        return null;
      }

      function isDismissed() {
        var storage = getStorage();
        if (!storage) return false;
        try {
          return storage.getItem(storageKey) === '1';
        } catch (e) {
          return false;
        }
      }

      function persistDismissal() {
        var storage = getStorage();
        if (!storage) return;
        try {
          storage.setItem(storageKey, '1');
        } catch (e) {}
      }

      if (isDismissed()) return;

      window.setTimeout(function() {
        if (!dialog.open) {
          lastActiveElement = document.activeElement;
          dialog.showModal();
          closeBtn.focus();
        }
      }, delay * 1000);

      function dismiss() {
        dialog.close();
        if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
          lastActiveElement.focus();
        }
        persistDismissal();
      }

      closeBtn.addEventListener('click', dismiss);

      dialog.addEventListener('cancel', function(event) {
        event.preventDefault();
        dismiss();
      });

      dialog.addEventListener('click', function(event) {
        var rect = dialog.getBoundingClientRect();
        var inside = rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
        if (!inside) dismiss();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-product-recommendations]').forEach(function(root) {
      var productId = root.getAttribute('data-product-id');
      if (!productId) return;

      var sectionId = root.getAttribute('data-section-id');
      var limit = root.getAttribute('data-limit') || '4';
      var grid = root.querySelector('[data-product-recommendations-grid]');
      if (!grid) return;

      function loadRecommendations() {
        if (root.dataset.loaded === 'true') return;
        root.dataset.loaded = 'true';

        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
          ? window.Shopify.routes.root
          : '/';
        var url = rootPath + 'recommendations/products?section_id=' + encodeURIComponent(sectionId) + '&product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(limit);

        fetch(url)
          .then(function(res) { return res.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var replacement = doc.querySelector('[data-product-recommendations-grid]');
            if (replacement) {
              grid.innerHTML = replacement.innerHTML;
            }
          })
          .catch(function() {
            var empty = root.querySelector('[data-product-recommendations-empty]');
            if (empty) {
              empty.hidden = false;
              empty.textContent = root.getAttribute('data-no-results-label') || '';
            }
          });
      }

      if (!('IntersectionObserver' in window)) {
        loadRecommendations();
        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        if (entries.some(function(entry) { return entry.isIntersecting; })) {
          observer.disconnect();
          loadRecommendations();
        }
      }, {
        rootMargin: '300px 0px'
      });

      observer.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var currentMediaIndex = 0;

    function setActiveMedia(container, index) {
      if (!container) return;
      index = String(index);
      currentMediaIndex = parseInt(index, 10) || 0;
      var items = container.querySelectorAll('[data-media-index]');
      var thumbs = container.querySelectorAll('[data-thumb-index]');
      var mainEl = container.querySelector('.product-media__main');

      items.forEach(function(item) {
        var isActive = item.getAttribute('data-media-index') === index;
        item.classList.toggle('product-media__item--active', isActive);
        if (!isActive) {
          var v = item.querySelector('video');
          if (v) { v.pause(); v.currentTime = 0; }
        }
      });

      thumbs.forEach(function(t) {
        t.classList.toggle('product-media__thumb--active', t.getAttribute('data-thumb-index') === index);
      });

      var counterEl = container.querySelector('[data-media-counter-current]');
      if (counterEl) counterEl.textContent = String(currentMediaIndex + 1);

      var activeThumb = container.querySelector('.product-media__thumb--active');
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      if (mainEl) {
        var activeItem = container.querySelector('.product-media__item--active');
        var img = activeItem ? activeItem.querySelector('img') : null;
        if (img && !img.complete) {
          mainEl.classList.add('is-loading');
          img.addEventListener('load', function onLoad() {
            mainEl.classList.remove('is-loading');
            img.removeEventListener('load', onLoad);
          });
          img.addEventListener('error', function onErr() {
            mainEl.classList.remove('is-loading');
            img.removeEventListener('error', onErr);
          });
        } else {
          mainEl.classList.remove('is-loading');
        }
      }
    }

    function getMediaCount() {
      var mc = document.querySelector('.product-media');
      return mc ? mc.querySelectorAll('[data-media-index]').length : 0;
    }

    function advanceMedia(delta) {
      var mc = document.querySelector('.product-media');
      if (!mc) return;
      var total = getMediaCount();
      if (total <= 1) return;
      var next = (currentMediaIndex + delta + total) % total;
      setActiveMedia(mc, next);
    }

    document.addEventListener('click', function(e) {
      var thumb = e.target.closest('[data-thumb-index]');
      if (!thumb) return;
      var index = thumb.getAttribute('data-thumb-index');
      var container = thumb.closest('.product-media');
      setActiveMedia(container, index);
    });

    /* ===== Mobile swipe on main image ===== */
    (function() {
      var main = document.querySelector('.product-media__main');
      if (!main) return;
      var startX = 0, startY = 0, tracking = false;
      main.addEventListener('touchstart', function(e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      main.addEventListener('touchend', function(e) {
        if (!tracking) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
        if (dx < 0) advanceMedia(1);
        else advanceMedia(-1);
      }, { passive: true });
    })();

    /* ===== Lightbox (images + videos) ===== */
    (function() {
      var lightbox = document.querySelector('[data-lightbox]');
      if (!lightbox) return;
      var img = lightbox.querySelector('[data-lightbox-img]');
      var vid = lightbox.querySelector('[data-lightbox-video]');
      var closeBtn = lightbox.querySelector('[data-lightbox-close]');
      var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
      var nextBtn = lightbox.querySelector('[data-lightbox-next]');
      var counter = lightbox.querySelector('[data-lightbox-counter]');
      var wrap = lightbox.querySelector('[data-lightbox-wrap]');
      var mediaItems = [];
      var lbIndex = 0;

      document.querySelectorAll('.product-media__item').forEach(function(item) {
        var zoomImg = item.querySelector('.product-media__zoomable');
        var videoWrap = item.querySelector('[data-media-type]');
        if (zoomImg) {
          mediaItems.push({
            type: 'image',
            src: zoomImg.getAttribute('data-zoom-src') || zoomImg.currentSrc || zoomImg.src,
            alt: zoomImg.getAttribute('data-alt') || zoomImg.getAttribute('alt') || ''
          });
        } else if (videoWrap) {
          var videoEl = videoWrap.querySelector('video');
          var sources = videoEl ? videoEl.querySelectorAll('source') : [];
          var mp4 = '';
          sources.forEach(function(s) { if (/mp4/.test(s.type || s.src)) mp4 = s.src; });
          if (!mp4 && videoEl) mp4 = videoEl.src || videoEl.currentSrc || '';
          if (!mp4 && sources.length) mp4 = sources[0].src;
          if (mp4) mediaItems.push({ type: 'video', src: mp4 });
        }
      });
      if (mediaItems.length === 0) return;

      function stopLightboxVideo() {
        vid.pause();
        vid.removeAttribute('src');
        vid.style.display = 'none';
      }

      function loadLightboxMedia(idx) {
        lbIndex = idx;
        if (counter) counter.textContent = (lbIndex + 1) + ' / ' + mediaItems.length;
        var item = mediaItems[lbIndex];

        if (item.type === 'video') {
          img.style.display = 'none';
          img.src = '';
          img.classList.remove('is-loading');
          wrap.classList.remove('is-loading');
          vid.src = item.src;
          vid.style.display = 'block';
          vid.play().catch(function() {});
        } else {
          stopLightboxVideo();
          img.style.display = '';
          img.classList.add('is-loading');
          wrap.classList.add('is-loading');
          img.alt = item.alt || '';
          img.src = item.src;
        }
      }

      img.addEventListener('load', function() {
        img.classList.remove('is-loading');
        wrap.classList.remove('is-loading');
      });

      img.addEventListener('error', function() {
        img.classList.remove('is-loading');
        wrap.classList.remove('is-loading');
      });

      function showLightbox(idx) {
        if (prevBtn) prevBtn.hidden = mediaItems.length <= 1;
        if (nextBtn) nextBtn.hidden = mediaItems.length <= 1;
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        loadLightboxMedia(idx);
      }

      function hideLightbox() {
        lightbox.hidden = true;
        document.body.style.overflow = '';
        img.src = '';
        img.style.display = '';
        img.classList.remove('is-loading');
        wrap.classList.remove('is-loading');
        stopLightboxVideo();
      }

      document.querySelector('.product-media__main').addEventListener('click', function(e) {
        if (e.target.closest('video') || e.target.closest('.product-media__video')) {
          var item = e.target.closest('[data-media-index]');
          if (!item) return;
          var idx = parseInt(item.getAttribute('data-media-index'), 10);
          showLightbox(idx);
          return;
        }
        var target = e.target.closest('.product-media__zoomable');
        if (!target) return;
        var item = target.closest('[data-media-index]');
        var idx = item ? parseInt(item.getAttribute('data-media-index'), 10) : 0;
        showLightbox(idx);
      });

      closeBtn.addEventListener('click', hideLightbox);

      lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox || e.target === wrap) hideLightbox();
      });

      if (prevBtn) prevBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        loadLightboxMedia((lbIndex - 1 + mediaItems.length) % mediaItems.length);
      });

      if (nextBtn) nextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        loadLightboxMedia((lbIndex + 1) % mediaItems.length);
      });

      document.addEventListener('keydown', function(e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') hideLightbox();
        if (e.key === 'ArrowLeft') prevBtn && prevBtn.click();
        if (e.key === 'ArrowRight') nextBtn && nextBtn.click();
      });

      /* Lightbox swipe */
      var lbStartX = 0, lbTracking = false;
      wrap.addEventListener('touchstart', function(e) {
        if (e.touches.length !== 1) return;
        lbStartX = e.touches[0].clientX;
        lbTracking = true;
      }, { passive: true });
      wrap.addEventListener('touchend', function(e) {
        if (!lbTracking) return;
        lbTracking = false;
        var dx = e.changedTouches[0].clientX - lbStartX;
        if (Math.abs(dx) < 40) return;
        if (dx < 0 && nextBtn) nextBtn.click();
        else if (dx > 0 && prevBtn) prevBtn.click();
      }, { passive: true });
    })();

    var productForm = document.querySelector('[data-product-form]');
    if (!productForm) return;

    var productActions = productForm.querySelector('.product-form__actions');
    var mediaContainer = document.querySelector('.product-media');
    var variantsNode = productForm.querySelector('[data-product-variants]');
    var variantMediaMapNode = productForm.querySelector('[data-variant-media-map]');
    var variantIdInput = productForm.querySelector('[data-product-variant-id]');
    var optionInputs = productForm.querySelectorAll('[data-product-option]');
    var addButton = productForm.querySelector('[data-add-to-cart-button]');
    var skuNode = document.querySelector('[data-product-sku]');
    var dynamicCheckoutWrapper = productForm.querySelector('[data-dynamic-checkout-wrapper]');
    var pickupContainer = document.querySelector('[data-pickup-availability]');
      var decisionRail = document.querySelector('[data-decision-rail]');
      var decisionVariantTitle = decisionRail ? decisionRail.querySelector('[data-decision-variant-title]') : null;
      var decisionAvailability = decisionRail ? decisionRail.querySelector('[data-decision-availability]') : null;
      var decisionStock = decisionRail ? decisionRail.querySelector('[data-decision-stock]') : null;
      var decisionStatusDot = decisionRail ? decisionRail.querySelector('[data-decision-status-dot]') : null;
      var dispatchCountdownNode = decisionRail ? decisionRail.querySelector('[data-dispatch-countdown]') : null;
      var variantGuidance = productForm.querySelector('[data-variant-guidance]');
      var feedbackNode = productForm.querySelector('[data-product-feedback]');
      var mobileSticky = productForm.querySelector('[data-product-mobile-sticky]');
      var mobileStickyButton = mobileSticky ? mobileSticky.querySelector('[data-mobile-sticky-add]') : null;
      var mobileStickyPrice = mobileSticky ? mobileSticky.querySelector('[data-mobile-sticky-price]') : null;
      var mobileStickyStatus = mobileSticky ? mobileSticky.querySelector('[data-mobile-sticky-status]') : null;
      var priceRoot = productForm.querySelector('[data-price-root]');
    var priceCurrentValue = priceRoot ? priceRoot.querySelector('[data-price-current-value]') : null;
    var priceCompare = priceRoot ? priceRoot.querySelector('[data-price-compare]') : null;
    var priceCompareValue = priceRoot ? priceRoot.querySelector('[data-price-compare-value]') : null;
    var priceUnit = priceRoot ? priceRoot.querySelector('[data-price-unit]') : null;
    var priceUnitValue = priceRoot ? priceRoot.querySelector('[data-price-unit-value]') : null;
    var mobileMediaQuery = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';

    if (!variantsNode || !variantIdInput) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      return;
    }

    var variantMediaMap = null;
    if (variantMediaMapNode) {
      try {
        variantMediaMap = JSON.parse(variantMediaMapNode.textContent);
      } catch (error) {
        variantMediaMap = null;
      }
    }

    function updatePrice(matchedVariant) {
      if (!matchedVariant) return;

      if (priceCurrentValue) {
        priceCurrentValue.textContent = formatMoney(matchedVariant.price);
      }

      if (priceCompare && priceCompareValue) {
        var compare = matchedVariant.compare_at_price || 0;
        var onSale = compare > matchedVariant.price;
        priceCompare.hidden = !onSale;
        if (onSale) {
          priceCompareValue.textContent = formatMoney(compare);
        }
      }

      if (priceUnit && priceUnitValue) {
        var unitPrice = matchedVariant.unit_price || null;
        var measurement = matchedVariant.unit_price_measurement || null;
        if (!unitPrice || !measurement) {
          priceUnit.hidden = true;
        } else {
          var refValue = measurement.reference_value || 1;
          var refUnit = measurement.reference_unit || '';
          var suffix = (refValue && refValue !== 1) ? (String(refValue) + refUnit) : refUnit;
          priceUnitValue.textContent = formatMoney(unitPrice) + ' / ' + suffix;
          priceUnit.hidden = false;
        }
      }
    }

    function updateVariantMedia(matchedVariant) {
      if (!matchedVariant || !mediaContainer || !variantMediaMap) return;
      var mediaId = variantMediaMap[String(matchedVariant.id)];
      if (!mediaId) return;
      var target = mediaContainer.querySelector('[data-media-id="' + String(mediaId) + '"]');
      if (!target) return;
      var index = target.getAttribute('data-media-index');
      if (!index) return;
      setActiveMedia(mediaContainer, index);
    }

    function updateDecisionRail(matchedVariant) {
      if (!decisionRail || !matchedVariant) return;

      var lowStockThreshold = parseInt(decisionRail.getAttribute('data-low-stock-threshold') || '0', 10);
      var lowStockTemplate = decisionRail.getAttribute('data-low-stock-template') || '';
      var availableLabel = decisionRail.getAttribute('data-available-label') || '';
      var soldOutLabel = decisionRail.getAttribute('data-sold-out-label') || '';
      var unavailableLabel = decisionRail.getAttribute('data-unavailable-label') || soldOutLabel;
      var inStockLabel = decisionRail.getAttribute('data-in-stock-label') || '';
      var outOfStockLabel = decisionRail.getAttribute('data-out-of-stock-label') || '';

      if (decisionVariantTitle && matchedVariant.title && matchedVariant.title !== 'Default Title') {
        decisionVariantTitle.textContent = matchedVariant.title;
      }

      if (decisionAvailability) {
        decisionAvailability.textContent = matchedVariant.available ? availableLabel : soldOutLabel;
      }

      if (decisionStatusDot) {
        decisionStatusDot.classList.toggle('is-off', !matchedVariant.available);
      }

      if (decisionStock) {
        var stockLabel = inStockLabel;
        if (!matchedVariant.available) {
          stockLabel = outOfStockLabel;
        } else if (matchedVariant.inventory_management && matchedVariant.inventory_policy !== 'continue' && matchedVariant.inventory_quantity <= lowStockThreshold) {
          stockLabel = lowStockTemplate.replace('__COUNT__', String(matchedVariant.inventory_quantity));
        }
        decisionStock.textContent = stockLabel;
      }
    }

      function updateDispatchCountdown() {
        if (!dispatchCountdownNode) return;

      var cutoffHour = parseInt(dispatchCountdownNode.getAttribute('data-cutoff-hour') || '16', 10);
      if (Number.isNaN(cutoffHour)) cutoffHour = 16;
      if (cutoffHour < 0) cutoffHour = 0;
      if (cutoffHour > 23) cutoffHour = 23;

      var now = new Date();
      var cutoff = new Date(now.getTime());
      cutoff.setHours(cutoffHour, 0, 0, 0);

      var hoursTemplate = dispatchCountdownNode.getAttribute('data-template-hours') || '';
      var tomorrowTemplate = dispatchCountdownNode.getAttribute('data-template-tomorrow') || '';

      if (now <= cutoff) {
        var diffMs = cutoff.getTime() - now.getTime();
        var hoursLeft = Math.max(1, Math.ceil(diffMs / 3600000));
        dispatchCountdownNode.textContent = hoursTemplate.replace('__HOURS__', String(hoursLeft));
      } else {
        dispatchCountdownNode.textContent = tomorrowTemplate;
      }
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try {
          if (window.theme && window.theme.moneyFormat) {
            return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
          }
          return window.Shopify.formatMoney(cents);
        } catch (error) {
        }
      }

      var amount = Number(cents || 0) / 100;
      var localeCode = document.documentElement.lang || 'en';
      var currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

      try {
        return new Intl.NumberFormat(localeCode, { style: 'currency', currency: currencyCode }).format(amount);
      } catch (error) {
        return amount.toFixed(2);
      }
    }

    function setVariantGuidance(matchedVariant, unavailableCombo) {
      if (!variantGuidance) return;

      var soldOutMessage = variantGuidance.getAttribute('data-sold-out-message') || '';
      var unavailableMessage = variantGuidance.getAttribute('data-unavailable-message') || soldOutMessage;

      variantGuidance.classList.remove('is-unavailable');

      if (unavailableCombo) {
        variantGuidance.textContent = unavailableMessage;
        variantGuidance.classList.add('is-unavailable');
        variantGuidance.hidden = false;
        return;
      }

      if (!matchedVariant) {
        variantGuidance.textContent = unavailableMessage;
        variantGuidance.classList.add('is-unavailable');
        variantGuidance.hidden = false;
        return;
      }

      if (matchedVariant.available === false) {
        variantGuidance.textContent = soldOutMessage;
        variantGuidance.classList.add('is-unavailable');
        variantGuidance.hidden = false;
        return;
      }

      variantGuidance.textContent = '';
      variantGuidance.hidden = true;
    }

    function syncStickyAddButton(label, disabled, loading) {
      if (!mobileStickyButton) return;
      if (label) {
        mobileStickyButton.textContent = label;
      }
      mobileStickyButton.disabled = Boolean(disabled);
      mobileStickyButton.classList.toggle('is-loading', Boolean(loading));
      if (loading) {
        mobileStickyButton.setAttribute('aria-busy', 'true');
      } else {
        mobileStickyButton.removeAttribute('aria-busy');
      }
    }

    function updateMobileSticky(matchedVariant, unavailableCombo) {
      if (!mobileSticky) return;

      var addLabel = mobileStickyButton ? (mobileStickyButton.getAttribute('data-add-label') || '') : '';
      var soldLabel = mobileStickyButton ? (mobileStickyButton.getAttribute('data-sold-label') || '') : '';
      var unavailableMessage = variantGuidance
        ? (variantGuidance.getAttribute('data-unavailable-message') || '')
        : '';

      if (unavailableCombo || !matchedVariant) {
        if (mobileStickyPrice) mobileStickyPrice.textContent = '';
        if (mobileStickyStatus) mobileStickyStatus.textContent = unavailableMessage;
        syncStickyAddButton(soldLabel, true, false);
        return;
      }

      if (mobileStickyPrice) {
        mobileStickyPrice.textContent = formatMoney(matchedVariant.price);
      }

      if (mobileStickyStatus) {
        if (matchedVariant.available) {
          mobileStickyStatus.textContent = decisionStock ? decisionStock.textContent : '';
        } else {
          mobileStickyStatus.textContent = variantGuidance
            ? (variantGuidance.getAttribute('data-sold-out-message') || '')
            : '';
        }
      }

      syncStickyAddButton(matchedVariant.available ? addLabel : soldLabel, !matchedVariant.available, false);
    }

    var stickyTicking = false;
    var lastScrollY = window.scrollY || 0;
    var stickyHiddenByScroll = false;

    function updateMobileStickyVisibility() {
      if (!mobileSticky) return;

      if (mobileMediaQuery && !mobileMediaQuery.matches) {
        mobileSticky.hidden = true;
        document.body.classList.remove('has-mobile-sticky-cta');
        return;
      }

      if (document.body.classList.contains('cart-drawer-open')) {
        mobileSticky.hidden = true;
        document.body.classList.remove('has-mobile-sticky-cta');
        return;
      }

      if (!productActions) {
        mobileSticky.hidden = false;
        document.body.classList.add('has-mobile-sticky-cta');
        return;
      }

      var actionsRect = productActions.getBoundingClientRect();
      var actionsVisible = actionsRect.top < window.innerHeight && actionsRect.bottom > 0;
      if (actionsVisible) {
        mobileSticky.hidden = true;
        document.body.classList.remove('has-mobile-sticky-cta');
        return;
      }

      var footerEl = document.querySelector('footer, .footer, [data-footer]');
      if (footerEl) {
        var footerRect = footerEl.getBoundingClientRect();
        if (footerRect.top < window.innerHeight - 60) {
          mobileSticky.hidden = true;
          document.body.classList.remove('has-mobile-sticky-cta');
          return;
        }
      }

      mobileSticky.hidden = stickyHiddenByScroll;
      document.body.classList.toggle('has-mobile-sticky-cta', !stickyHiddenByScroll);
    }

    function updateStickyScrollDirection() {
      var currentY = window.scrollY || 0;
      var delta = currentY - lastScrollY;
      if (Math.abs(delta) > 6) {
        stickyHiddenByScroll = delta > 0;
        lastScrollY = currentY;
      } else if (delta === 0) {
        stickyHiddenByScroll = false;
      }
      lastScrollY = currentY;
    }

    function queueStickyVisibilityUpdate() {
      if (stickyTicking) return;
      stickyTicking = true;
      window.requestAnimationFrame(function() {
        stickyTicking = false;
        updateStickyScrollDirection();
        updateMobileStickyVisibility();
      });
    }

    function setFeedback(message, isError, withViewCartLink) {
      if (!feedbackNode || !message) return;

      var cartUrl = feedbackNode.getAttribute('data-cart-url') || (rootPath + 'cart');
      var viewCartLabel = feedbackNode.getAttribute('data-view-cart-label') || '';

      feedbackNode.classList.toggle('is-error', Boolean(isError));
      feedbackNode.hidden = false;

      if (withViewCartLink && viewCartLabel) {
        feedbackNode.innerHTML = message + ' <a href="' + cartUrl + '">' + viewCartLabel + '</a>';
      } else {
        feedbackNode.textContent = message;
      }
    }

    function updateCartCount(count) {
      var toggles = document.querySelectorAll('[data-cart-toggle]');
      toggles.forEach(function(toggle) {
        var badge = toggle.querySelector('.header__cart-count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'header__cart-count';
            toggle.appendChild(badge);
          }
          badge.textContent = String(count);
        } else if (badge) {
          badge.remove();
        }
      });
    }

    function fetchCartState() {
      return fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(cart) {
          if (cart && typeof cart.item_count === 'number') {
            updateCartCount(cart.item_count);
          }
          return cart;
        })
        .catch(function() { return null; });
    }

    var isInitialVariantLoad = true;

    function updateVariant(preserveFeedback) {
      var matchedVariant = null;
      if (optionInputs.length > 0) {
        var selectedOptions = Array.prototype.map.call(optionInputs, function(input) {
          return input.value;
        });
        matchedVariant = variants.find(function(variant) {
          return selectedOptions.every(function(optionValue, index) {
            return variant.options[index] === optionValue;
          });
        });
      } else {
        matchedVariant = variants.find(function(variant) {
          return String(variant.id) === String(variantIdInput.value);
        }) || variants[0];
      }

      if (!matchedVariant) {
        var unavailableLabel = decisionRail
          ? (decisionRail.getAttribute('data-unavailable-label') || decisionRail.getAttribute('data-sold-out-label') || '')
          : '';
        var outOfStockLabel = decisionRail
          ? (decisionRail.getAttribute('data-out-of-stock-label') || '')
          : '';

        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = addButton.getAttribute('data-sold-out-label') || '';
        }
        if (decisionVariantTitle) {
          decisionVariantTitle.textContent = unavailableLabel;
        }
        if (decisionAvailability) {
          decisionAvailability.textContent = unavailableLabel;
        }
        if (decisionStatusDot) {
          decisionStatusDot.classList.add('is-off');
        }
        if (decisionStock) {
          decisionStock.textContent = outOfStockLabel;
        }
        setVariantGuidance(null, true);
        updateMobileSticky(null, true);
        queueStickyVisibilityUpdate();
        return;
      }

      variantIdInput.value = matchedVariant.id;

      if (skuNode) {
        skuNode.textContent = matchedVariant.sku || '';
      }

      if (addButton) {
        if (matchedVariant.available) {
          addButton.disabled = false;
          addButton.textContent = addButton.getAttribute('data-add-to-cart-label') || '';
        } else {
          addButton.disabled = true;
          addButton.textContent = addButton.getAttribute('data-sold-out-label') || '';
        }
      }

      if (dynamicCheckoutWrapper) {
        dynamicCheckoutWrapper.hidden = !matchedVariant.available;
      }

      if (feedbackNode && !preserveFeedback) {
        feedbackNode.hidden = true;
        feedbackNode.classList.remove('is-error');
      }

      updateDecisionRail(matchedVariant);
      updatePrice(matchedVariant);
      if (!isInitialVariantLoad) {
        updateVariantMedia(matchedVariant);
      }
      isInitialVariantLoad = false;
      setVariantGuidance(matchedVariant, false);
      updateMobileSticky(matchedVariant, false);
      queueStickyVisibilityUpdate();

      if (pickupContainer) {
        var sectionId = pickupContainer.getAttribute('data-section-id');
        var productUrl = pickupContainer.getAttribute('data-product-url');
        var url = productUrl + '?variant=' + matchedVariant.id + '&section_id=' + sectionId;
        fetch(url)
          .then(function(res) { return res.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newPickup = doc.querySelector('[data-pickup-availability]');
            if (newPickup) {
              pickupContainer.innerHTML = newPickup.innerHTML;
            }
          })
          .catch(function() {});
      }
    }

    if (optionInputs.length > 0) {
      optionInputs.forEach(function(optionInput) {
        optionInput.addEventListener('change', updateVariant);
      });
    }

    var pillContainers = productForm.querySelectorAll('[data-option-pills]');
    pillContainers.forEach(function(container) {
      var selectId = container.getAttribute('data-for');
      var hiddenSelect = document.getElementById(selectId);
      if (!hiddenSelect) return;

      container.addEventListener('click', function(e) {
        var pill = e.target.closest('.product-option-pill');
        if (!pill) return;

        container.querySelectorAll('.product-option-pill').forEach(function(p) {
          p.classList.remove('is-selected');
        });
        pill.classList.add('is-selected');

        hiddenSelect.value = pill.getAttribute('data-pill-value');
        hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

      updateDispatchCountdown();
    if (window.__soukDispatchCountdownTimer) {
      window.clearInterval(window.__soukDispatchCountdownTimer);
    }
    window.__soukDispatchCountdownTimer = window.setInterval(updateDispatchCountdown, 60000);

    updateVariant();

    if (mobileStickyButton) {
      mobileStickyButton.addEventListener('click', function(event) {
        event.preventDefault();
        if (!addButton || addButton.disabled) return;
        if (typeof productForm.requestSubmit === 'function') {
          productForm.requestSubmit();
        } else {
          addButton.click();
        }
      });
    }

    if (mobileSticky) {
      window.addEventListener('scroll', queueStickyVisibilityUpdate, { passive: true });
      window.addEventListener('resize', queueStickyVisibilityUpdate);
      document.addEventListener('cart:updated', queueStickyVisibilityUpdate);
      if (mobileMediaQuery) {
        if (typeof mobileMediaQuery.addEventListener === 'function') {
          mobileMediaQuery.addEventListener('change', queueStickyVisibilityUpdate);
        } else if (typeof mobileMediaQuery.addListener === 'function') {
          mobileMediaQuery.addListener(queueStickyVisibilityUpdate);
        }
      }
      queueStickyVisibilityUpdate();
    }

    var sellingPlanInput = productForm.querySelector('[data-selling-plan-input]');
    var sellingPlanRadios = productForm.querySelectorAll('[data-selling-plan-radio]');

    if (sellingPlanInput && sellingPlanRadios.length > 0) {
      sellingPlanRadios.forEach(function(radio) {
        radio.addEventListener('change', function() {
          sellingPlanInput.value = radio.value;
        });
      });
    }

    var dynamicCheckoutWrapperEl = productForm.querySelector('[data-dynamic-checkout-wrapper]');

    productForm.addEventListener('submit', function(event) {
      event.preventDefault();
      if (!addButton || addButton.disabled) return;

      var defaultLabel = addButton.getAttribute('data-add-to-cart-label') || addButton.textContent;
      var addingLabel = addButton.getAttribute('data-adding-label') || defaultLabel;
      var addedLabel = addButton.getAttribute('data-added-label') || defaultLabel;
      var errorLabel = addButton.getAttribute('data-error-label') || defaultLabel;
      var addedMessage = feedbackNode ? (feedbackNode.getAttribute('data-added-message') || addedLabel) : addedLabel;
      var errorMessage = feedbackNode ? (feedbackNode.getAttribute('data-error-message') || errorLabel) : errorLabel;

      var formData = new FormData(productForm);
      var endpoint = productForm.getAttribute('action') || (rootPath + 'cart/add');
      if (!endpoint.endsWith('.js')) {
        endpoint += '.js';
      }
      var requestFailed = false;

      addButton.disabled = true;
      addButton.classList.add('is-loading');
      addButton.setAttribute('aria-busy', 'true');
      addButton.textContent = addingLabel;
      syncStickyAddButton(addingLabel, true, true);

      fetch(endpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(function(res) {
          if (!res.ok) {
            var error = new Error('add_failed');
            error.status = res.status;
            throw error;
          }
          return res.json();
        })
        .then(function() {
          addButton.textContent = addedLabel;
          syncStickyAddButton(addedLabel, true, false);
          setFeedback(addedMessage, false, true);
          return fetchCartState();
        })
        .then(function(cart) {
          var detail = { source: 'product-form', openDrawer: true };
          if (cart) detail.cart = cart;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
        })
        .catch(function() {
          requestFailed = true;
          addButton.textContent = errorLabel;
          syncStickyAddButton(errorLabel, true, false);
          setFeedback(errorMessage, true, false);
        })
        .finally(function() {
          addButton.classList.remove('is-loading');
          addButton.removeAttribute('aria-busy');
          window.setTimeout(function() {
            updateVariant(requestFailed);
          }, 1100);
        });
    });

    var productPage = document.querySelector('[data-product-page]');
    if (productPage) {
      var disallowedHandles = {
        'image-aspect-ratio': true,
        'image-aspect-ratio-portrait': true
      };

      function isValidHandle(value) {
        return typeof value === 'string'
          && /^[a-z0-9][a-z0-9-]*$/.test(value)
          && !disallowedHandles[value];
      }

      var handle = productPage.getAttribute('data-product-handle');
      if (isValidHandle(handle)) {
        try {
          var key = 'souk_recently_viewed';
          var handles = JSON.parse(localStorage.getItem(key) || '[]');
          if (!Array.isArray(handles)) handles = [];
          handles = handles.filter(function(item) { return isValidHandle(item); });
          handles = handles.filter(function(item) { return item !== handle; });
          handles.unshift(handle);
          localStorage.setItem(key, JSON.stringify(handles.slice(0, 12)));
        } catch (e) {
        }
      }
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-quick-view-root]');
    if (!root) return;

    var dialog = root.querySelector('[data-quick-view-dialog]');
    var closeBtn = root.querySelector('[data-quick-view-close]');
    var content = root.querySelector('[data-quick-view-content]');
    if (!dialog || !closeBtn || !content) return;
    var loadingLabel = root.getAttribute('data-loading-label') || 'Loading';
    var noResultsLabel = root.getAttribute('data-no-results-label') || 'No results';
    var viewProductLabel = root.getAttribute('data-view-product-label') || 'View all';
    var localeCode = root.getAttribute('data-locale') || document.documentElement.lang || '';
    var routesRoot = root.getAttribute('data-routes-root') || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/');
    var lastActiveElement = null;

    var moneyFormat = root.getAttribute('data-money-format') || '';

    function normalizeRoot(path) {
      if (!path) return '/';
      var normalized = path;
      if (normalized.charAt(0) !== '/') normalized = '/' + normalized;
      if (normalized.charAt(normalized.length - 1) !== '/') normalized += '/';
      return normalized;
    }

    function buildProductPath(handle, asJson) {
      var path = normalizeRoot(routesRoot) + 'products/' + encodeURIComponent(handle) + (asJson ? '.js' : '');
      if (asJson && localeCode) {
        path += '?locale=' + encodeURIComponent(localeCode);
      }
      return path;
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatMoney(cents, format) {
      if (cents == null || !format) return '';
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      var withComma = parts[0] + ',' + parts[1];
      var noDecimals = parts[0];
      var withSpaceSeparator = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ',' + parts[1];
      var withApostropheSeparator = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'") + '.' + parts[1];
      var placeholders = [
        ['amount_with_apostrophe_separator', withApostropheSeparator],
        ['amount_with_comma_separator', withComma],
        ['amount_with_space_separator', withSpaceSeparator],
        ['amount_no_decimals_with_comma_separator', noDecimals],
        ['amount_no_decimals', noDecimals],
        ['amount', amount]
      ];
      var result = format;
      for (var i = 0; i < placeholders.length; i++) {
        var key = placeholders[i][0];
        var val = placeholders[i][1];
        result = result.replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g'), val);
      }
      return result;
    }

    function renderProductFallback(product, handle) {
      var image = product.featured_image ? '<img src="' + product.featured_image + '&width=900" alt="' + escapeHtml(product.title || '') + '" loading="lazy">' : '';
      var desc = (product.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 220);
      var price = formatMoney(product.price, moneyFormat);
      var productUrl = buildProductPath(product.handle || handle, false);

      content.innerHTML =
        '<div class="quick-view__media">' + image + '</div>' +
        '<div class="quick-view__details">' +
          '<h3>' + escapeHtml(product.title || '') + '</h3>' +
          '<p>' + escapeHtml(price) + '</p>' +
          '<p>' + escapeHtml(desc) + '</p>' +
          '<a class="btn btn--primary quick-view__cta" href="' + productUrl + '">' + escapeHtml(viewProductLabel) + '</a>' +
        '</div>';
    }

    function buildQuickViewSectionPath(handle) {
      var base = buildProductPath(handle, false);
      var joiner = base.indexOf('?') >= 0 ? '&' : '?';
      return base + joiner + 'section_id=quick-view-product';
    }

    document.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-quick-view-trigger]');
      if (!trigger) return;
      event.preventDefault();

      var handle = trigger.getAttribute('data-product-handle');
      if (!handle) return;

      lastActiveElement = trigger;
      content.innerHTML = '<p class="quick-view__loading">' + loadingLabel + '...</p>';
      dialog.showModal();

      fetch(buildQuickViewSectionPath(handle), { credentials: 'same-origin' })
        .then(function(res) { return res.ok ? res.text() : null; })
        .then(function(html) {
          if (html) {
            content.innerHTML = html;
            return;
          }

          // Fallback path: product JSON (no rich media support)
          return fetch(buildProductPath(handle, true), { credentials: 'same-origin' })
            .then(function(res) { return res.ok ? res.json() : null; })
            .then(function(product) {
              if (!product) return null;
              renderProductFallback(product, handle);
              return true;
            });
        })
        .catch(function() {
          content.innerHTML = '<p class="quick-view__loading">' + noResultsLabel + '</p>';
        });
    });

    function closeDialog() {
      dialog.close();
      if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus();
      }
    }

    closeBtn.addEventListener('click', function() {
      closeDialog();
    });

    dialog.addEventListener('click', function(event) {
      var rect = dialog.getBoundingClientRect();
      var inside = rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
      if (!inside) closeDialog();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-recently-viewed]').forEach(function(root) {
      var grid = root.querySelector('[data-recently-viewed-grid]');
      var empty = root.querySelector('[data-recently-viewed-empty]');
      if (!grid || !empty) return;

      var limit = Number(root.getAttribute('data-limit')) || 4;
      var moneyFormat = root.getAttribute('data-money-format') || '';
      var key = 'souk_recently_viewed';
      var handles = [];
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root
        : '/';
      var disallowedHandles = {
        'image-aspect-ratio': true,
        'image-aspect-ratio-portrait': true
      };

      function escapeHtml(str) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
      }

      function isValidHandle(value) {
        return typeof value === 'string'
          && /^[a-z0-9][a-z0-9-]*$/.test(value)
          && !disallowedHandles[value];
      }

      function formatMoney(cents, format) {
        if (cents == null || !format) return '';
        var amount = (cents / 100).toFixed(2);
        var parts = amount.split('.');
        var withComma = parts[0] + ',' + parts[1];
        var noDecimals = parts[0];
        var withSpaceSeparator = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ',' + parts[1];
        var withApostropheSeparator = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'") + '.' + parts[1];
        var placeholders = [
          ['amount_with_apostrophe_separator', withApostropheSeparator],
          ['amount_with_comma_separator', withComma],
          ['amount_with_space_separator', withSpaceSeparator],
          ['amount_no_decimals_with_comma_separator', noDecimals],
          ['amount_no_decimals', noDecimals],
          ['amount', amount]
        ];
        var result = format;
        for (var i = 0; i < placeholders.length; i++) {
          var k = placeholders[i][0];
          var val = placeholders[i][1];
          result = result.replace(new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}', 'g'), val);
        }
        return result;
      }

      function resolveLocalizedUrl(relativeUrl) {
        if (!relativeUrl || relativeUrl.charAt(0) !== '/' || rootPath === '/') return relativeUrl;
        if (relativeUrl.indexOf(rootPath) === 0) return relativeUrl;
        return rootPath.replace(/\/$/, '') + relativeUrl;
      }

      try {
        handles = JSON.parse(localStorage.getItem(key) || '[]');
      } catch (e) {
        handles = [];
      }

      if (!Array.isArray(handles)) handles = [];
      handles = handles
        .filter(function(handle) { return isValidHandle(handle); })
        .filter(function(handle, index, arr) { return arr.indexOf(handle) === index; });

      try {
        localStorage.setItem(key, JSON.stringify(handles.slice(0, 24)));
      } catch (e) {
      }

      function loadRecentlyViewed() {
        if (root.dataset.loaded === 'true' || !handles.length) return;
        root.dataset.loaded = 'true';

        var selected = handles.slice(0, limit);
        Promise.all(selected.map(function(handle) {
          return fetch(rootPath + 'products/' + encodeURIComponent(handle) + '.js')
            .then(function(res) { return res.ok ? res.json() : null; })
            .catch(function() { return null; });
        })).then(function(products) {
          var list = products.filter(Boolean);
          if (!list.length) {
            root.hidden = true;
            return;
          }

          empty.remove();
          list.forEach(function(product) {
            var item = document.createElement('a');
            item.className = 'recently-viewed__item';
            item.href = resolveLocalizedUrl(product.url);

            var localizedTitle = product.title;
            var image = product.featured_image ? '<img src="' + product.featured_image + '&width=700" alt="' + escapeHtml(localizedTitle || '') + '" loading="lazy">' : '';
            var price = formatMoney(product.price, moneyFormat);
            item.innerHTML = image + '<div class="recently-viewed__meta"><p class="recently-viewed__title">' + escapeHtml(localizedTitle) + '</p><p class="recently-viewed__price">' + price + '</p></div>';
            grid.appendChild(item);
          });
        });
      }

      if (!handles.length) {
        root.hidden = true;
        return;
      }

      if (!('IntersectionObserver' in window)) {
        loadRecentlyViewed();
        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        if (entries.some(function(entry) { return entry.isIntersecting; })) {
          observer.disconnect();
          loadRecentlyViewed();
        }
      }, {
        rootMargin: '300px 0px'
      });

      observer.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-slideshow]');
    if (!root) return;

    var track = root.querySelector('.slideshow__track');
    var slides = Array.from(root.querySelectorAll('.slideshow__slide'));
    var dots = Array.from(root.querySelectorAll('[data-slide-dot]'));
    var prevButton = root.querySelector('[data-slide-prev]');
    var nextButton = root.querySelector('[data-slide-next]');

    if (slides.length <= 1 || !track) return;

    var currentIndex = 0;
    var timer = null;
    var autoplayEnabled = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed, 10) || 5000;

    function setSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;
      track.style.transform = 'translateX(' + (-100 * currentIndex) + '%)';
      dots.forEach(function(dot, dotIndex) {
        var active = dotIndex === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      timer = window.setInterval(function() {
        setSlide(currentIndex + 1);
      }, speed);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prevButton) {
      prevButton.addEventListener('click', function() {
        setSlide(currentIndex - 1);
        startAutoplay();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function() {
        setSlide(currentIndex + 1);
        startAutoplay();
      });
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        setSlide(parseInt(dot.dataset.slideDot, 10));
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    setSlide(0);
    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();
})();
